import styled from 'styled-components';
import { Typography } from 'antd';
const { Text } = Typography;
import { color as colors } from '../../resources';

/*

  TextLarge  18px --> header
  TextMedium 16px--> title card
  TextSmall 14px --> menu, detail
  TextXSMall 12px --> ข้อความ 'โปรดระบุ'
*/

export const TextInputLabel = ({ color, bold, text, align, ...props }) => {
  return (
    <div>
      <TextStyle style={{ color }} bold={true} size={'20px'} align={align} {...props}>
        {text}
      </TextStyle>
    </div>
  );
};

export const TextXSMall = ({ color, bold, text, align, ...props }) => {
  return (
    <div>
      <TextStyle style={{ color }} bold={bold} size={'16px'} align={align} {...props}>
        {text}
      </TextStyle>
    </div>
  );
};

export const TextSmall = ({ color, bold, text, align, onClick, children, ...props }) => {
  return (
    <div>
      <TextStyle
        style={{ color }}
        bold={bold}
        size={'14px'}
        align={align}
        onClick={onClick}
        {...props}
      >
        {text || children}
      </TextStyle>
    </div>
  );
};

export const TextLarge = ({ color, bold, text, align, ...props }) => {
  return (
    <div>
      <TextStyle style={{ color }} bold={bold} size={'18px'} align={align} {...props}>
        {text}
      </TextStyle>
    </div>
  );
};

export const TextLogoLogin = ({ color, bold, text, align, ...props }) => {
  return (
    <div>
      <TextStyle style={{ color }} bold={bold} size={'30px'} align={align} {...props}>
        {text}
      </TextStyle>
    </div>
  );
};

export const TextTitle = ({ color, bold, text, align, ...props }) => {
  return (
    <div>
      <TextStyle style={{ color: color || colors.darkgrey,marginBottom: '20px' }} bold={bold} size={'24px'} align={align} {...props}>
        {text}
      </TextStyle>
    </div>
  );
};

export const TextHeadTitle = ({ color, bold, text, align, ...props }) => {
  return (
    <div>
      <TextStyle style={{ color:colors.theme}} bold={bold} size={'32px'} align={align} {...props}>
        {text}
      </TextStyle>
    </div>
  );
};

export const TextCustom = ({ color, bold, text, align, size,children, styled,...props }) => {
  return (
    <div style={styled}>
      <TextStyle style={{ color }} bold={bold} size={size} align={align} {...props}>
          {children || text}
      </TextStyle>
    </div>
  );
};

const TextStyle = styled(Text)`
  font-weight: ${(props) => (props.bold ? 'bold' : 'unset')};
  font-size: ${(props) => (props.size ? props.size : '12px')};
  text-align: ${(props) => (props.align ? props.align : '')};
  margin: 5px;
  font-family: HeaventRoundedLight, 'sans-serif' !important;
`;
